export enum StatusSignalR {
  Unknown, // Status inicial, desconhecido.
  Connected, // Quando esta conectado.
  Connecting, // Quando está iniciando a conexão com o servidor.
  Disconnected, // Quando está desconectado.
  Disconnecting, // Quando está iniciando uma desconexão com o servidor.
  LogoutUser // Quando o usuário "saiu" da aplicação.
}
